import { GitexChallengeLanding } from '../components/gitex-challenge/GitexChallengeLanding';

export const GitexChallengePage = () => {
  return <GitexChallengeLanding />;
};

export default GitexChallengePage;
